import React from 'react';
import PropTypes from 'prop-types';
import { localize } from 'react-localize-redux';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import RichTextEditor from 'react-rte';

import PageBase from '../components/PageBase';

const PageBaseStyled = styled(PageBase)`
  margin-top: 10px !important;
`;

const Title = styled.h3`
  padding: 10px;
  background-color: #54708a;
  margin-top: 10px;
  color: white;
`;

const Protocol = styled.h4`
  margin: 15px 0;
`;

const StyledSubmitButton = styled(RaisedButton)`
  float: right;
`;

const Container = styled.div``;

const StyledDivider = styled(Divider)`
  margin: 20px 0 !important;
`;
/*
  PropTypes / DefaultProps
 */
const propTypes = {
  content: PropTypes.object,
  onChange: PropTypes.func,
  lang: PropTypes.any,
};

const defaultProps = {};

class TermsMessage extends React.Component {
  constructor(props) {
    super(props);
    this.message = null;

    this.state = {
      body: RichTextEditor.createEmptyValue(),
    };
  }

  componentWillMount() {
    this.message = this.props.content;
    this.setState({
      body: this.state.body.setContentFromString(this.message.body || '', 'html'),
    });
  }

  fieldChange = (newValue) => {
    this.message.body = newValue.toString('html');
    this.props.onChange(this.message);

    this.setState({
      body: newValue,
    });
  };

  render() {
    if (
      (!this.props.content && !this.props.lang) ||
      this.props.content.lang !== this.props.lang ||
      this.props.content.protocol !== 'NONE'
    ) {
      return null;
    }

    return (
      <Container>
        <RichTextEditor name="body" value={this.state.body} onChange={this.fieldChange} />
      </Container>
    );
  }
}

TermsMessage.propTypes = propTypes;
TermsMessage.defaultProps = defaultProps;

export default localize(TermsMessage, 'locale');



// WEBPACK FOOTER //
// ./src/components/TermsMessage.js